import React from 'react'
import {Tag} from 'antd'

const TagsType = ({record}) => {

    const outgoingTyes = {
        'NORMAL': 'Normal',
        'CONSIGNED': 'Konsinye',
        'ERROR': 'Hatalı İşlem',
        'SHIPPING_ORDER': 'Sevkiyat Emri'
    }

    return(
        <React.Fragment>
            <Tag color="processing">{outgoingTyes[record]}</Tag>
        </React.Fragment>
    )
}
export default TagsType